export const GET_COUNTRIES = "GET_COUNTRIES"
export const FILTER_BY_CONTINENT = "FILTER_BY_CONTINENT"
export const FILTER_BY_SEASON= "FILTER_BY_SEASON"
export const ORDER_BY_NAME = "ORDER_BY_NAME"
export const ORDER_BY_POPULATION = "ORDER_BY_POPULATION"
export const GET_COUNTRY_NAME = "GET_COUNTRY_NAME"
export const POST_ACTIVITY= "POST_ACTIVITY"
export const GET_COUNTRY_ID= "GET_COUNTRY_ID"
export const GET_ACTIVITIES= "GET_ACTIVITIES"
export const DELETE_ACTIVITIES= "DELETE_ACTIVITIES"
export const PUT_ACTIVITY= "PUT_ACTIVITY"